import * as bootstrap from "bootstrap";
import autoScroll from 'dom-autoscroller';

const dragula = require('dragula');
require('slick-carousel');

export default function () {
    $(function () {
        const $stack = $('#picture-stack');
        const imgSources: { [key: number]: string } = $stack.data('img-sources');
        const $pictureGroupArea = $(".picture-group-area");
        const $progress = $(".grouping-progress");
        const $progressBar = $('.progress-bar', $progress);
        const $affix = $('.affix');
        const picturesRequired: number = $progress.data('pictures-required');
        const picturesTotal: number = $progress.data('pictures-total');
        let enoughPicturesInfoShown = false;
        const groupNameLimit = 180;
        const groupNameBlacklist = /[^A-Za-z0-9äöüß!&/()?;,:.+`"'\[\]\- ]/gm; // Characters not allowed in heading
        const picturesAlreadyGrouped = $('.picture-groups .picture-group img').length;

        if (picturesRequired < picturesTotal && picturesAlreadyGrouped < picturesRequired) {
            $progressBar.removeClass('progress-bar-success');
            $progressBar.addClass('progress-bar-warning');
        }
        if (picturesAlreadyGrouped >= picturesRequired) {
            $('#next-button.disabled', 'form').removeClass('disabled');
        }

        $('.js-alert').closest('.alert').hide();

        $pictureGroupArea.on('input', '.card-header input', function () {
            if (isNamingCompleted()) {
                $('#next-button.disabled', 'form').removeClass('disabled');
            }
            $('.name-already-used').removeClass('name-already-used is-invalid');
        }).on('focusout', '.card-header input', function () {
            let groupName = $(this).val() as string;
            groupName = groupName.replace(groupNameBlacklist, '').trim();
            groupName = groupName.length > groupNameLimit ? groupName.substring(0, groupNameLimit) : groupName;
            if (groupName.length > 0) {
                $(this).removeClass('is-invalid');
            }
        });

        // @ts-ignore
        $stack.slick({draggable: false, revertOnSpill: true, copy: true, speed: 10});
        if ($('.img-placeholder', $stack).length > 0) {
            $stack.slick('slickRemove', 0);
        }

        $stack.change(function () {
            const picturesGrouped = $('img', $pictureGroupArea).length;
            bootstrap.Tooltip.getInstance($progressBar.get(0)).setContent({'.tooltip-inner': picturesGrouped + $progressBar.data('title-template')});
            $progressBar.css('width', Math.round(picturesGrouped / picturesTotal * 100) + '%');
            $progressBar.text(picturesGrouped + '/' + picturesTotal);
            if (picturesGrouped >= picturesRequired) {
                if ($progressBar.is('.progress-bar-warning')) {
                    $progressBar.removeClass('progress-bar-warning');
                    $progressBar.addClass('progress-bar-success');
                }
                if (!enoughPicturesInfoShown && !(picturesAlreadyGrouped > 0)) {
                    $('.picture-groups').removeClass('hidden-heading');
                    showAlert(picturesRequired < picturesTotal ? $('#enough-pictures-more-alert') : $('#enough-pictures-alert'));
                    enoughPicturesInfoShown = true;
                }
                if (isNamingCompleted()) {
                    $('#next-button.disabled', 'form').removeClass('disabled');
                }
            } else {
                $('#next-button:not(.disabled)', 'form').addClass('disabled');
                if (picturesRequired < picturesTotal && $progressBar.is('.progress-bar-success')) {
                    $progressBar.removeClass('progress-bar-success');
                    $progressBar.addClass('progress-bar-warning');
                }
            }
        });

        $('#stack-controls > div').on('click', (function () {
            if ($(this).hasClass('prev')) {
                $('#picture-stack').slick('slickPrev');
            }
            if ($(this).hasClass('next')) {
                $('#picture-stack').slick('slickNext');
            }
        }));

        const drake = dragula({
            isContainer: function (element: HTMLElement): boolean {
                return isStack(element) || isGroup(element);
            },
            moves: function (element: HTMLElement, source: HTMLElement): boolean {
                if (isStack(source)) {
                    return isImage($(element));
                }
                if (isGroup(source)) {
                    return isImage($('img', element));
                }
                return false;
            },
            accepts: function (el: HTMLElement, target: HTMLElement, source: HTMLElement): boolean {
                if (isStack(source)) {
                    return isGroup(target);
                }
                if (isGroup(source)) {
                    return isStack(target) || isGroup(target);
                }
                return false;
            }
        }).on('drop', function (element: HTMLElement, target: HTMLElement, source: HTMLElement) {
            const $img = $(element).is('img') ? $(element) : $('img', element);
            const itemID = $img.data('item-id');
            if (isStack(target)) {
                addPictureToStack($img.data('item-id'));
                // @ts-ignore
                const $droppedElement: JQuery = $(element, $stack);
                $droppedElement.siblings().show();
                $droppedElement.remove();
            } else if (isStack(source) && isGroup(target)) {
                if (isNewGroup(target)) {
                    addToNewGroup(itemID);
                } else {
                    addToGroup($(target), itemID, $('> img', target));
                }
                removeCurrentSlide();
                $stack.slick('slickNext');
            } else if (isGroup(source) && isNewGroup(target)) {
                addToNewGroup(itemID);
            }
            removeEmptyGroups();
        }).on('over', function (element: HTMLElement, container: HTMLElement) {
            if (isNewGroup(container)) {
                $(container).closest('.card').addClass('card-hover');
            } else {
                $('.new-picture-group .card-hover').removeClass('card-hover');
            }
        }).on('drag', function () {
            $('body').addClass('dragging');
        }).on('dragend', function () {
            $('body').removeClass('dragging');
        });

        // Scroll up/down when mouse is about to leave viewport while dragging a picture
        autoScroll([window], {
            margin: 300,
            maxSpeed: 1500,
            scrollWhenOutside: true,
            autoScroll: function () {
                return this.down && drake.dragging;
            }
        });

        $pictureGroupArea.on('click', '.add-picture', function () {
            const $currentSlide = $('.slick-active img');
            if (isImage($currentSlide)) {
                const itemID = $currentSlide.data('item-id');
                if ($(this).is('.new-picture-group .add-picture')) {
                    addToNewGroup(itemID);
                } else {
                    addToGroup($('.card-body', $(this).parent().siblings('.card')), itemID);
                }
                removeCurrentSlide();
            }
        });

        $pictureGroupArea.on('mouseenter', '.img-remove', function () {
            $(this).siblings('img').addClass("opacity");
        }).on('mouseleave', '.img-remove', function () {
            $(this).siblings('img').removeClass("opacity");
        }).on('click', '.img-remove', function () {
            const $itemElement = $(this).siblings('img');
            if (isImage($itemElement)) {
                $(this).closest('.img-container').remove();
                addPictureToStack($itemElement.data('item-id'));
            }
            removeEmptyGroups();
        });

        $pictureGroupArea.on('mouseenter', '.remove-group', function () {
            $(this).parent().siblings('.card').addClass("opacity");
        }).on('mouseleave', '.remove-group', function () {
            $(this).parent().siblings('.card').removeClass("opacity");
        }).on('click', '.remove-group', function () {
            $($('.img-container > img', $(this).parent().siblings('.card')).get().reverse()).each(function () {
                if (isImage($(this))) {
                    addPictureToStack($(this).data('item-id'));
                }
            });
            $(this).closest('.row').remove();
            $stack.trigger('change');
        });

        $(".new-picture-group .card .fas").on('mouseenter', function () {
            $(this).closest('.card').addClass("add");
        }).on('mouseleave', function () {
            $(this).closest('.card').removeClass("add");
        }).on('click', function () {
            addNewGroup();
        });

        $('#next-button[type="submit"]', 'form').parent().on('click', function () {
            $('.alert').hide();

            const $nextButton = $(this).find('#next-button');
            const picturesGrouped = $('img', $pictureGroupArea).length;
            if (picturesGrouped < picturesRequired) {
                showAlert($('#not-enough-pictures-alert'));
                return false;
            }
            removeEmptyGroups();
            if (!isNamingCompleted()) {
                $('.card-header input', $pictureGroupArea).each(function () {
                    if (($(this).val() as string).length < 1) {
                        $(this).addClass('is-invalid');
                    }
                });
                showAlert($('#missing-input-alert'));
                return false;
            }
            const groupTitles: string[] = [];
            const pictureGroups: { [key: string]: number[] }[] = [];
            let groupNamesNotUnique = false;
            $('.card-header input', $pictureGroupArea).each(function () {
                const group: { [key: string]: number[] } = {};
                const groupTitle = $(this).val() as string;
                if (groupTitles.indexOf(groupTitle) >= 0) {
                    $(this).addClass('is-invalid name-already-used');
                    groupNamesNotUnique = true;
                    return false;
                }
                groupTitles.push(groupTitle);
                const itemIDs: number[] = [];
                $('img', $(this).closest('.picture-group')).each(function () {
                    if (isImage($(this))) {
                        itemIDs.push($(this).data('item-id'));
                    }
                });
                group[groupTitle] = itemIDs;
                pictureGroups.push(group);
            });
            if (groupNamesNotUnique) {
                showAlert($('#group-names-not-unique'));
                return false;
            }
            const pictureGroupsJson = JSON.stringify(pictureGroups);
            const $itemInput = $('.picture-grouping-element > input[name!="clientTime"]', $nextButton.closest('form'));
            $itemInput.val(pictureGroupsJson);

            const date = new Date();
            const $clientTimeInput = $('.picture-grouping-element > input[name="clientTime"]', $nextButton.closest('form'));
            $clientTimeInput.val(date.getTime());
        });

        $affix.width($affix.parent().width());

        function isStack(container: HTMLElement): boolean {
            return $(container).is('.slick-slide > div') || $(container).is('.slick-list');
        }

        function isGroup(container: HTMLElement): boolean {
            return $(container).is('.card-body');
        }

        function isNewGroup(container: HTMLElement): boolean {
            return $(container).is('.new-picture-group .card-body');
        }

        function addPictureToStack(itemID: number): void {
            if ($('.slick-active').length > 0) {
                const currentSlideIndex = $stack.slick('slickCurrentSlide');
                $stack.slick('slickAdd', `<div><div><img alt="" src="${imgSources[itemID]}" data-item-id="${itemID}"/></div></div>`, currentSlideIndex, true);
            } else {
                $stack.slick('slickAdd', `<div><div><img alt="" src="${imgSources[itemID]}" data-item-id="${itemID}"/></div></div>`);
            }
            $stack.trigger('change');
        }

        function removeCurrentSlide(): void {
            const slideIndex = $stack.slick('slickCurrentSlide');
            $stack.slick('slickRemove', slideIndex);
        }

        function addToGroup($groupContainer: JQuery<HTMLElement>, itemID: number, $elToBeReplaced?: JQuery<HTMLElement>): void {
            const imgSrc = imgSources[itemID];
            const newImgElement = `<div class="img-container"><img alt="" src="${imgSrc}" data-item-id="${itemID}"/><div class="img-remove"><i class="fas fa-minus-circle"></i></div></div>`;
            if ($elToBeReplaced !== undefined) {
                $elToBeReplaced.replaceWith(newImgElement);
            } else {
                $groupContainer.append(newImgElement);
            }
            $stack.trigger('change');
        }

        function addToNewGroup(itemID: number): void {
            $('div, img', $('.new-picture-group .card-body')).remove();
            $('.new-picture-group .card-hover').removeClass('card-hover');
            addNewGroup();
            addToGroup($('.picture-groups > .picture-group:first-child .card-body'), itemID);
        }

        function removeEmptyGroups(): void {
            $('.picture-groups > .picture-group').each(function () {
                if ($('img', $(this)).length < 1) {
                    $(this).remove();
                }
            });
        }

        function addNewGroup(): void {
            $('.picture-groups').prepend($('#group-template').html());
        }

        function isNamingCompleted(): boolean {
            let isNamingCompleted = true;
            $('.card-header input', $pictureGroupArea).each(function () {
                if (($(this).val() as string).length < 1) {
                    isNamingCompleted = false;
                    return false;
                }
            });
            return isNamingCompleted;
        }

        function showAlert($textEl: JQuery<HTMLElement>): void {
            $textEl.show();
            $textEl.closest('.alert').show();
            window.scrollTo(0, 0);
        }

        function isImage($element: JQuery<HTMLElement>): boolean {
            const itemID = $element.data('item-id');
            return $element.is('img') && itemID in imgSources;
        }
    });
}